import { render, staticRenderFns } from "./ComparativePlan.vue?vue&type=template&id=794f87f2"
import script from "./ComparativePlan.vue?vue&type=script&lang=js"
export * from "./ComparativePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports